import CustomIcon from "./CustomIcon";
import React from "react";

const CustomButton = ({children, disabled, onClick, className, title, isIconButton= false}) => {
  return (
    <button title={title}
      className={`${disabled ? "bg-secondary-200 border-secondary-200 cursor-not-allowed" : "bg-secondary-500 hover:bg-secondary-800 hover:shadow-md active:bg-secondary-800 active:shadow-md cursor-pointer border-secondary-500"} text-white text-sm ${isIconButton ? "px-2" : "px-4"} py-2 rounded-lg${className ? ` ${className}` : ''} focus:outline-none focus:ring-4 focus:secondary-500 focus:ring-offset-2 focus:ring-offset-white transition-all border-2 flex`}
      disabled={disabled} onClick={onClick}>{children}</button>
  );
};

export const ButtonTertiary = ({children, disabled, onClick, className, title, isIconButton= false}) => {
  return (
    <button title={title}
      className={`${disabled ? "opacity-60 cursor-not-allowed border-transparent" : "hover:bg-primary-800 hover:shadow-md active:bg-primary-800 active:shadow-md cursor-pointer border-primary-500"} bg-primary-500 text-white text-sm ${isIconButton ? "px-2" : "px-4"} py-2 rounded-lg${className ? ` ${className}` : ''} focus:outline-none focus:ring-4 focus:secondary-500 focus:ring-offset-2 focus:ring-offset-white transition-all border-2 flex`}
      disabled={disabled} onClick={onClick}>{children}</button>
  );
};

export const SecondaryButton = ({children, disabled, onClick, className, title, isIconButton= false}) => {
  return (
    <button title={title}
      className={`${disabled ? "bg-gray-100 border-gray-100 text-gray-300 cursor-not-allowed" : "text-rand-100 bg-gray-200 hover:bg-gray-300 hover:shadow-md active:bg-gray-300 active:shadow-md cursor-pointer border-gray-200"} text-sm ${isIconButton ? "px-2" : "px-4"} py-2 rounded-lg${className ? ` ${className}` : ''} focus:outline-none focus:ring-4 focus:secondary-500 focus:ring-offset-2 focus:ring-offset-white transition-all border-2 flex`}
      disabled={disabled} onClick={onClick}>{children}</button>
  );
};

export const SemiTransparentButton = ({children, disabled, onClick, className, title, isIconButton= false}) => {
  return (
    <button title={title}
      className={`${disabled ? "cursor-not-allowed text-white/40" : "hover:bg-opacity-40 hover:shadow-md active:bg-opacity-70 active:shadow-md cursor-pointer"} bg-opacity-20 bg-white text-sm ${isIconButton ? "px-2" : "px-4"} py-2.5 rounded-lg${className ? ` ${className}` : ''} focus:outline-none focus:ring-4 focus:secondary-500 focus:ring-offset-2 focus:ring-offset-white transition-all`}
      disabled={disabled} onClick={onClick}>{children}</button>
  );
};

export const OutlinedButton = ({children, disabled, onClick, className, title, isIconButton= false}) => {
  return (
    <button title={title}
      className={`${disabled ? "border-gray-100 text-gray-300 cursor-not-allowed" : "bg-transparent border-secondary-400 hover:border-secondary-800 active:border-secondary-800 cursor-pointer text-secondary-500"} border-2 text-sm ${isIconButton ? "px-2" : "px-4"} py-2 rounded-lg${className ? ` ${className}` : ''} focus:outline-none focus:ring-4 focus:secondary-500 focus:ring-offset-2 focus:ring-offset-white transition-all flex`}
      disabled={disabled} onClick={onClick}>{children}</button>
  );
};

export const DangerButton = ({children, disabled, onClick, className, title, isIconButton= false}) => {
  return (
    <button title={title}
      className={`${disabled ? "bg-red-200 border-rose-200 cursor-not-allowed" : "bg-error-500 hover:bg-error-800  hover:shadow-md active:bg-error-800 active:shadow-md cursor-pointer border-error-500"} text-sm text-white ${isIconButton ? "px-2" : "px-4"} py-2 rounded-lg${className ? ` ${className}` : ''} focus:outline-none  focus:ring-4 focus:secondary-500 focus:ring-offset-2 focus:ring-offset-white transition-all border-2 flex`}
      disabled={disabled} onClick={onClick}>{children}</button>
  );
};

export const LinkButton = ({children, disabled, onClick, className, title, isIconButton= false}) => {
  return (
    <button title={title}
      className={`${disabled ? "text-gray-300 cursor-not-allowed" : "text-secondary-500 hover:text-secondary-300 cursor-pointer"} text-sm ${className ? ` ${className}` : ''} focus:outline-none  focus:ring-4 focus:secondary-500 focus:ring-offset-2 focus:ring-offset-white transition-all `}
      disabled={disabled} onClick={onClick}>{children}</button>
  );
};

export const IconButton = ({icon, disabled, onClick, className, iconColor, size}) => {
  return (
    <button onClick={disabled ? undefined: onClick}
          className={`${disabled ? "cursor-not-allowed opacity-40" : "cursor-pointer"} flex justify-center items-center transition-colors bg-gray-200 hover:bg-gray-50 focus:ring focus:outline-none rounded-full leading-none ${className ? `${className}` : "w-6 h-6"}`}>
    <CustomIcon icon={`${icon ? `${icon}` : 'close'}`} size={`${size ? size : "lg"}`} className={`${iconColor ? `${iconColor}` : "text-error-500"}`}/>
  </button>
  );
};


export default CustomButton;
